import { memo, useCallback } from 'react'
import classNames from 'classnames'
import { Venue, VenueEvent } from 'types/model'
import { DayDetail } from 'types/ui/calendar'

import { PosterImage } from '@elements/poster-image'
import { Popover } from '@elements/popover'
import { usePopover } from '@hooks/popover'

export const EventCalendarCell = memo(function EventCalendarCell({
  event,
  venue,
  dayDetail,
  pastEvent,
  onClick,
}: {
  event?: VenueEvent
  venue: Venue
  dayDetail: DayDetail
  pastEvent: boolean
  onClick: (val: VenueEvent) => void
}) {
  const popover = usePopover()

  const handleClick = useCallback(() => {
    if (!event) return
    onClick(event)
  }, [event, onClick])
  return (
    <div
      className={classNames('group/cell', {
        'relative cursor-pointer hover:scale-[120%] rounded-none hover:rounded hover:overflow-clip border border-transparent hover:border-standard-light scale-100 transition-transform hover:z-[1]':
          !!event && !pastEvent,
        'min-h-full': !event,
        '!cursor-not-allowed': pastEvent,
      })}
    >
      {pastEvent && (
        <>
          <div
            ref={popover.setAnchorElement}
            className="absolute inset-0 w-full h-full cursor-not-allowed opacity-70 bg-neutral-500"
          />
          <Popover {...popover.props}>Event has ended</Popover>
        </>
      )}
      {event && event.primaryImage && (
        <div
          onClick={handleClick}
          className={classNames('contents ', {
            '!cursor-not-allowed': pastEvent,
          })}
        >
          <div className="w-full h-auto shadow-md text-foreground dark:text-dark-foreground">
            <PosterImage
              alt={event.name}
              src={event.primaryImage.filename}
              w="268"
              h="268"
              className="w-full h-auto aspect-square"
            />
            <div className="flex flex-col items-start justify-start p-1 pb-1.5 space-y-1 bg-card">
              <span className="heading-sm min-h-[32px] h-[32px] line-clamp-2 group-hover/cell:h-auto group-hover/cell:max-h-[64px] group-hover/cell:line-clamp-4">
                {event.name}
              </span>
            </div>
          </div>
        </div>
      )}
      {!event && <div className="w-full h-auto aspect-square" />}
      <div className="absolute top-0 right-0 flex items-center justify-center w-6 h-6 bg-white rounded-bl-sm shadow-md">
        <span className="font-bold text-center text-black heading-md">
          {dayDetail.day}
        </span>
      </div>
    </div>
  )
})
